const PaymentStatus = {
    APPROVED: 1,
    DECLINED: 2,
};

export default PaymentStatus;